import { Helmet } from "react-helmet-async";
import { SITE_NAME, SITE_URL, SOCIAL_IMAGE } from "../constants/site";

const DEFAULT_TITLE = "Parcelin - Affordable Parcel Delivery South Africa | Same Day & Overnight Courier";
const DEFAULT_DESCRIPTION =
  "Send parcels across South Africa with Parcelin. Affordable same-day & overnight delivery from Gauteng to Limpopo. Save up to 60% on courier costs. Track your parcel in real-time.";

function canonicalUrlFor(path) {
  const pathWithoutTrailingSlash = path.replace(/\/+$/, "");
  return pathWithoutTrailingSlash ? `${SITE_URL}${pathWithoutTrailingSlash}` : `${SITE_URL}/`;
}

export default function SEO({ title, description, path, noIndex }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const pageDescription = description || DEFAULT_DESCRIPTION;
  const canonicalUrl = path !== undefined && !noIndex ? canonicalUrlFor(path) : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={pageDescription} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_ZA" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={pageDescription} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:image" content={SOCIAL_IMAGE.url} />
      <meta property="og:image:width" content={String(SOCIAL_IMAGE.width)} />
      <meta property="og:image:height" content={String(SOCIAL_IMAGE.height)} />
      <meta property="og:image:alt" content={SOCIAL_IMAGE.alt} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={SOCIAL_IMAGE.url} />
      <meta name="twitter:image:alt" content={SOCIAL_IMAGE.alt} />
    </Helmet>
  );
}
